import { useState, useEffect, useCallback } from 'react';
import {Form, InputGroup, Button} from 'react-bootstrap';
import debounce from "lodash.debounce";
import * as Slider from '@radix-ui/react-slider';
import * as consts from '../consts';

const DEFAULT_COUNTRY = consts.COUNTRIES_DATA[0];
const MAX_RANGE_VALUE = 100;

const presenceData = [
    {label: 'High', value: 'High'},
    {label: 'Medium', value: 'Medium'},
    {label: 'Low', value: 'Low'},
    {label: 'N/A', value: 'None'},
];

const reputationData = [
    {label: 'High', value: 'High'},
    {label: 'Medium', value: 'Medium'},
    {label: 'Low', value: 'Low'},
    {label: 'N/A', value: 'None'},
];

function MLeadFilters(props) {
    const [clearAllVisible, setClearAllVisible] = useState(false);
    const [selectedKeywords, setSelectedKeywords] = useState('');
    const [textValues, setTextValues] = useState({});
    const [checkValues, setCheckValues] = useState({});
    const [toggleValues, setToggleValues] = useState({});
    const [reputationValues, setReputationValues] = useState([]);
    const [presenceValues, setPresenceValues] = useState([]);
    const [filterModel, setFilterModel] = useState({});
    const [branchCountRange, setBranchCountRange] = useState([0, 100]);
    const [forceFilterModel, setForceFilterModel] = useState(false);

    useEffect(() => {
        if (props.listFilters) {
            handleKeywordsChange({target: {value: props.listFilters.filterKeywords}});
        } else {
            resetFilterModel()
        }
    }, [props.listFilters])

    function updateFilterModel(eDataValue, filterValue) {
        setFilterModel((prevData) => {
            if (Object.keys(filterValue).length <= 0) {
                // Remove the key from prevData
                const { [eDataValue]: _, ...rest } = prevData;
                return rest;
            }
            // Otherwise, add/update the key
            return {
                ...prevData,
                [eDataValue]: filterValue,
            }; 
        });

        setForceFilterModel(true);
    }

    function handleKeywordsChange(e) {
        const eKeywords = e.target.value;
        setSelectedKeywords(eKeywords);
        handleDebouncedKeywordsChange(eKeywords);
    }

    const handleDebouncedKeywordsChange = useCallback(
        debounce((eKeywords) => {
            props.pmlkw(eKeywords);
        }, 500),
        []
    );

    function handleRangeChange(values) {
        setBranchCountRange(values);

        // handleDebouncedRangeChange(values, eDataValue);
    }

    function applyRangeChange() {
        const eDataValue = 'branchcount';
        const eValue = branchCountRange;
        var filterValue = {}; 
        if ((eValue[0] < MAX_RANGE_VALUE) && (eValue[1] <= MAX_RANGE_VALUE)) {
            filterValue = {filterType: "number", type: "inRange", filter: eValue[0], filterTo: eValue[1]}
        } else if (eValue[0] > 0 ) {
            filterValue = {filterType: "number", type: "greaterThanOrEqual", filter: MAX_RANGE_VALUE}
        } else {
            filterValue = {};
        }
        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     [eDataValue]: filterValue,
        // }));
        updateFilterModel(eDataValue, filterValue);
    }
    /*
    const handleDebouncedRangeChange = useCallback(
        debounce((eValue) => {
            var filterValue = {}; 
            if ((eValue[0] < MAX_RANGE_VALUE) && (eValue[1] <= MAX_RANGE_VALUE)) {
                filterValue = {filterType: "number", type: "inRange", filter: eValue[0], filterTo: eValue[1]}
            } else if (eValue[0] > 0 ) {
                filterValue = {filterType: "number", type: "greaterThanOrEqual", filter: MAX_RANGE_VALUE}
            } else {
                filterValue = {};
            }
            setFilterModel((prevData) => ({
                ...prevData,
                [eDataValue]: filterValue,
            }));
        }, 500),
        []
    )
    */
    function handleTextChange(e) {
        const eDataValue = e.currentTarget.dataset.value;
        const eValue = e.target.value; 
        const eCheckValue = checkValues[eDataValue]??false;
        const eToggleValue = toggleValues[eDataValue]??false;

        setTextValues((prevData) => ({
            ...prevData,
            [eDataValue]: eValue,
        }))

        handleDebouncedTextChange(eValue, eDataValue, eCheckValue, eToggleValue);
    }

    const handleDebouncedTextChange = useCallback(
        debounce((eValue, eDataValue, eCheckValue, eToggleValue) => {
            var filterValue = {}; 
            filterValue = {filterType: "text", type: "contains", filter: eValue};

            if (eDataValue === 'tld') {
                if (eValue.length > 0) {
                    setCheckValues((prevData) => ({
                        ...prevData,
                        [eDataValue]: true,
                    }))

                    setToggleValues((prevData) => ({
                        ...prevData,
                        [eDataValue]: true,
                    }))
                } else if (eCheckValue) {
                    filterValue = {filterType: "text", type: eToggleValue ? "notBlank" : "blank"}
                }
            }

            // setFilterModel((prevData) => ({
            //     ...prevData,
            //     [eDataValue]: filterValue,
            // }));
            updateFilterModel(eDataValue, filterValue);
        }, 500),
        []
    );

    function handleCheckChange(e) {
        const eDataType = e.currentTarget.dataset.type;
        const eDataToggle = JSON.parse(e.currentTarget.dataset.toggle);
        const eDataValue = e.currentTarget.dataset.value;
        const eChecked = e.target.checked;
        const eTextValue = textValues[eDataValue]??'';

        var checkValue = false;
        var toggleValue = false;
        var filterValue = {}; 
        if (eDataToggle) {
            checkValue = true;
            toggleValue = eChecked;
            if (eDataType === "number") {
                filterValue = {filterType: "number", type: "equals", filter: eChecked ? 1 : 0}
            } else if (eDataType === "text") {
                filterValue = {filterType: "text", type: eChecked ? "notBlank" : "blank"}
            }
        } else if (eChecked) {
            checkValue = eChecked;
            toggleValue = eChecked;
            if (eDataType === "number") {
                filterValue = {filterType: "number", type: "equals", filter: 1}
            } else if (eDataType === "text") {
                filterValue = {filterType: "text", type: "notBlank"}
            }
        }

        if (eDataValue === 'tld') {
            if (checkValue && !toggleValue) {
                setTextValues((prevData) => ({
                    ...prevData,
                    [eDataValue]: '',
                }))
            } else if (eTextValue.length > 0) {
                filterValue = {filterType: "number", type: "contains", filter: eTextValue}
            }
        }

        setCheckValues((prevData) => ({
            ...prevData,
            [eDataValue]: checkValue,
        }))

        setToggleValues((prevData) => ({
            ...prevData,
            [eDataValue]: toggleValue,
        }))

        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     [eDataValue]: filterValue,
        // }));
        updateFilterModel(eDataValue, filterValue);
    }

    useEffect(() => {
        const filterKeys = Object.keys(props.leadsFilterModel);

        var updatedTextValues = {};
        var updatedCheckValues = {};
        var updatedToggleValues = {};
        var updatedPresenceValues = [];
        var updatedReputationValues = [];

        filterKeys.map(filterKey => {
            const filterValue = props.leadsFilterModel[filterKey];

            if (filterValue.filterType === 'text') {
                if (filterValue.type === 'blank') {
                    updatedCheckValues[filterKey] = true;
                    updatedToggleValues [filterKey] = false;
                } if (filterValue.type === 'notBlank') {
                    updatedCheckValues[filterKey] = true;
                    updatedToggleValues [filterKey] = true;
                } else {
                    updatedTextValues[filterKey] = filterValue.filter??''
                }
            } else if (filterValue.filterType === 'number') {
                if (filterValue.type === 'equals') {
                    if (parseInt(filterValue.filter) === 1) {
                        updatedCheckValues[filterKey] = true;
                        updatedToggleValues[filterKey] = true;
                    } else if (parseInt(filterValue.filter) === 0) {
                        updatedCheckValues[filterKey] = true;
                        updatedToggleValues[filterKey] = false;
                    }
                } else if (filterKey === 'branchcount') {
                    setBranchCountRange([filterValue.filter??0, filterValue.filterTo??MAX_RANGE_VALUE])
                } 
            } else if (filterValue.filterType === 'set') {
                if (filterKey === 'marketpresence') {
                    updatedPresenceValues = filterValue.values  
                } else if (filterKey === 'marketreputation') {
                    updatedReputationValues = filterValue.values
                }
            }
        });

        setTextValues(updatedTextValues);
        setCheckValues(updatedCheckValues);
        setToggleValues(updatedToggleValues);
        setPresenceValues(updatedPresenceValues);
        setReputationValues(updatedReputationValues);

        if (!filterKeys.includes('branchcount')) {
            setBranchCountRange([0, MAX_RANGE_VALUE])
        }

        setFilterModel(props.leadsFilterModel);
    }, [props.leadsFilterModel])

    function handlePresenceSelection(e) {
        const eDataValue = e.currentTarget.dataset.value;
        const eChecked = e.target.checked;

        var presenceConditions = [];

        if (eChecked) {
            presenceConditions = [...presenceValues, eDataValue]
        } else {
            presenceConditions = presenceValues.filter(e => e !== eDataValue)
        }

        var filterValue = {filterType: "set", values: presenceConditions};
        if (presenceConditions.length === presenceData.length) {
            presenceConditions = [];
            filterValue = {};
        }

        setPresenceValues(presenceConditions);
        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     ['marketpresence']: filterValue,
        // }));
        updateFilterModel('marketpresence', filterValue);
    }

    function handleReputationSelection(e) {
        const eDataValue = e.currentTarget.dataset.value;
        const eChecked = e.target.checked;

        var reputationConditions = [];

        if (eChecked) {
            reputationConditions = [...reputationValues, eDataValue]
        } else {
            reputationConditions = reputationValues.filter(e => e !== eDataValue)
        }

        var filterValue = {filterType: "set", values: reputationConditions};
        if (reputationConditions.length === reputationData.length) {
            reputationConditions = [];
            filterValue = {};
        }

        setReputationValues(reputationConditions);
        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     ['marketreputation']: filterValue,
        // }));
        updateFilterModel('marketreputation', filterValue);
    }

    useEffect(() => {
        if (forceFilterModel) {
            props.pmlfm(filterModel);
            setForceFilterModel(false);
        }
    }, [forceFilterModel])

    function resetFilterModel() {
        props.pmlkw('');
        props.pmlfm({});
        
        setSelectedKeywords([]);
        setFilterModel({});
        setCheckValues({});
        setTextValues({});
        setToggleValues({});
        setPresenceValues([]);
        setReputationValues([]);
    }

    useEffect(() => {
        if (clearAllVisible) {
            resetFilterModel()
        }
    }, [props.forceReset])

    useEffect(() => {
        const cav = (presenceValues.length > 0) || (reputationValues.length > 0) || (selectedKeywords.length > 0) || (Object.keys(textValues).filter(key => (textValues[key] !== '')).length > 0) || (Object.keys(checkValues).filter(key => checkValues[key]).length > 0);
        setClearAllVisible(cav);
        props.pcav("leads",cav);
    }, [presenceValues, reputationValues, selectedKeywords, textValues, checkValues])

    return (
        <div className="p-2 border border-gray">
            <div className="mb-3 d-flex flex-row business-step4">
                <div style={{fontWeight: "700", fontSize: "13px"}}><i className="me-1 bi bi-buildings"></i>BUSINESS</div>
                <div className={`ms-auto ${clearAllVisible && false ? 'd-flex' : 'd-none'}`} style={{color: "#ff3f6c", fontWeight: "700", fontSize: "13px", cursor: "pointer"}} onClick={resetFilterModel}>CLEAR ALL</div>
            </div>
            <Form id="frmMCatalogFilters" autocomplete="off">
                <div className="mb-3">
                    <Form.Label id="lblKeywords" for="ctlKeywords">Hidden Gems</Form.Label>
                    <InputGroup>
                        <Form.Control size="sm" id="ctlKeywords" data-value="Keywords" data-type="text" className="border border-primary" type="search" value={selectedKeywords} onChange={handleKeywordsChange}></Form.Control>
                    </InputGroup>
                </div>
                <div className="mb-3">
                    <Form.Label id="lblName" for="ctlName">Company</Form.Label>
                    <InputGroup>
                        <Form.Control size="sm" id="ctlName" data-value="trimmedname" data-toggle={false} data-type="text" className="border border-primary" type="search" value={textValues.trimmedname??''} onChange={handleTextChange}></Form.Control>
                    </InputGroup>
                </div>
                <div className="mb-3">
                    <Form.Label id="lblWebsite" for="ctlWebsite">Web Site</Form.Label>
                    <InputGroup>
                        <Form.Control size="sm" id="ctlWebsite" data-value="tld" data-toggle={false} data-type="text" className="border border-primary" type="search" value={textValues.tld??''} onChange={handleTextChange}></Form.Control>
                    </InputGroup>
                </div>
                <div className="mb-3">
                    <Form.Label id="lblCity" for="ctlCity">City</Form.Label>
                    <InputGroup>
                        <Form.Control size="sm" id="ctlCity" data-value="city" data-toggle={false} data-type="text" className="border border-primary" type="search" value={textValues.city??''} onChange={handleTextChange}></Form.Control>
                    </InputGroup>
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlAddress" data-value="fulladdress" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.fulladdress} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblAddress" for="ctlAddress">Address</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsAddress" data-value="fulladdress" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.fulladdress} disabled={!checkValues.fulladdress} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlPhone" data-value="phone" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.phone} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblPhone" for="ctlPhone">Phone Number</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsPhone" data-value="phone" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.phone} disabled={!checkValues.phone} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlTld" data-value="tld" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.tld} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblTld" for="ctlTld">Web Site</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsTld" data-value="tld" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.tld} disabled={!checkValues.tld} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlEmail" data-value="isemail" data-toggle={false} data-type="number" className="border border-primary" type="checkbox" checked={checkValues.isemail} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblEmail" for="ctlEmail">Email</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsEmail" data-value="isemail" data-toggle={true} data-type="number" className="ms-auto" type="switch" checked={toggleValues.isemail} disabled={!checkValues.isemail} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlPeople" data-value="ispeople" data-toggle={false} data-type="number" className="border border-primary" type="checkbox" checked={checkValues.ispeople} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblPeople" for="ctlPeople">People</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsPeople" data-value="ispeople" data-toggle={true} data-type="number" className="ms-auto" type="switch" checked={toggleValues.ispeople} disabled={!checkValues.ispeople} onChange={handleCheckChange} />
                </div>
                <div className="mb-1">
                    <Form.Label id="lblPresenceContainer" for="ctlPresenceContainer">Market Presence</Form.Label>
                </div>
                <div id="divPresenceContainer" className='mb-3 p-1 rounded border border-1 border-primary'>
                    {presenceData.map((row, index) => { return (
                        <Form.Check id={`presence-${index}`} >
                            <Form.Check.Input className="border border-1 border-primary" data-value={row.value} type="checkbox" checked={presenceValues.includes(row.value)} onChange={handlePresenceSelection} />
                            <Form.Check.Label>{row.label}</Form.Check.Label>
                        </Form.Check>
                        )}
                    )}
                </div>
                <div className="mb-1">
                    <Form.Label id="lblReputationContainer" for="ctlReputationContainer">Market Reputation</Form.Label>
                </div>
                <div id="divReputationContainer" className='mb-3 p-1 rounded border border-1 border-primary'>
                    {presenceData.map((row, index) => { return (
                        <Form.Check id={`reputation-${index}`} >
                            <Form.Check.Input className="border border-1 border-primary" data-value={row.value} type="checkbox" checked={reputationValues.includes(row.value)} onChange={handleReputationSelection} />
                            <Form.Check.Label>{row.label}</Form.Check.Label>
                        </Form.Check>
                        )}
                    )}
                </div>
                <div class="mb-3">
                    <Form.Label id="lblBranchCount" for="ctlBranchCount">Branch Count</Form.Label>
                    <div className="d-flex flex-row align-items-center">
                        <Slider.Root
                            data-value="branchcount"                        
                            className="my-1 w-100 d-flex align-items-center position-relative"
                            value={branchCountRange}
                            onValueChange={handleRangeChange}
                            min={0}
                            max={MAX_RANGE_VALUE}
                            step={1}
                            minStepsBetweenThumbs={1}
                            style={{ height: 16 }}
                        >
                            <Slider.Track
                                className="position-relative bg-secondary rounded w-100"
                                style={{ height: 6 }}
                            >
                            <Slider.Range
                                className="position-absolute bg-primary rounded"
                                style={{ height: 6 }}
                            />
                            </Slider.Track>
                            <Slider.Thumb
                                className="text-center my-auto bg-white border border-primary d-block rounded-circle shadow"
                                style={{ width: 24, height: 24, cursor: "pointer" }}
                            >{branchCountRange[0] > 0 ? branchCountRange[0] : <i class="bi bi-skip-start-fill"></i>}</Slider.Thumb>
                            <Slider.Thumb
                                className="text-center my-auto bg-white border border-primary d-block rounded-circle shadow"
                                style={{ width: 24, height: 24, cursor: "pointer" }}
                            >{branchCountRange[1] < MAX_RANGE_VALUE ? branchCountRange[1] : <i class="bi bi-skip-end-fill"></i>}</Slider.Thumb>
                        </Slider.Root>
                        <Button className="ms-2" size="sm" onClick={applyRangeChange}>Go</Button>
                    </div>
                </div>
                <div className="my-2"><Form.Label id="lblWebSiteGroup" className="p-1 rounded bg-primary text-white w-100 fs-6">Web Site</Form.Label></div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlCareers" data-value="careersurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.careersurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblCareers" for="ctlCareers">Careers Page</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsCareers" data-value="careersurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.careersurl} disabled={!checkValues.careersurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlLeadership" data-value="leadershipurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.leadershipurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblLeadership" for="ctlLeadership">Team Page</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsTeam" data-value="leadershipurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.leadershipurl} disabled={!checkValues.leadershipurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlInvestor" data-value="investorurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.investorurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblInvestor" for="ctlInvestor">Investor Page</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsInvestor" data-value="investorurl" data-toggle={true} data-type="Text" className="ms-auto" type="switch" checked={toggleValues.investorurl} disabled={!checkValues.investorurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlProduct" data-value="producturl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.producturl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblProduct" for="ctlProduct">Product(s) Page</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsProduct" data-value="producturl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.producturl} disabled={!checkValues.producturl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlCart" data-value="carturl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.carturl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblCart" for="ctlCart">Shopping Cart</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsCart" data-value="carturl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.carturl} disabled={!checkValues.carturl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlApp" data-value="mobileapps" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.mobileapps} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblApp" for="ctlApp">Mobile App</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsApp" data-value="mobileapps" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.mobileapps} disabled={!checkValues.mobileapps} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlAbout" data-value="abouturl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.abouturl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblAbout" for="ctlAbout">About Page</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsAbout" data-value="abouturl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.abouturl} disabled={!checkValues.abouturl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlContactPage" data-value="contacturl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.contacturl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblContactPage" for="ctlContactPage">Contact Page</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsContactPage" data-value="contacturl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.contacturl} disabled={!checkValues.contacturl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlContactForm" data-value="isformonsite" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.isformonsite} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblContactForm" for="ctlContactForm">Contact Form</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsContactForm" data-value="isformonsite" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.isformonsite} disabled={!checkValues.isformonsite} onChange={handleCheckChange} />
                </div>
                <div className="my-2"><Form.Label id="lblSocialMediaGroup" className="p-1 rounded bg-primary text-white w-100 fs-6">Social Media</Form.Label></div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlLinkedIn" data-value="linkedinurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.linkedinurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblLinkedIn" for="ctlLinkedIn">LinkedIn</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlLinkedIn" data-value="linkedinurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.linkedinurl} disabled={!checkValues.linkedinurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlFacebook" data-value="facebookurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.facebookurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblFacebook" for="ctlFacebook">Facebook</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlFacebook" data-value="facebookurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.facebookurl} disabled={!checkValues.facebookurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlTwitter" data-value="twitterurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.twitterurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblTwitter" for="ctlTwitter">X (Twitter)</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlTwitter" data-value="twitterurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.twitterurl} disabled={!checkValues.twitterurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlInstagram" data-value="instagramurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.instagramurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblInstagram" for="ctlInstagram">Instagram</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlInstagram" data-value="instagramurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.instagramurl} disabled={!checkValues.instagramurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlYouTube" data-value="youtubeurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.youtubeurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblYouTube" for="ctlYouTube">YouTube</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlYouTube" data-value="youtubeurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.youtubeurl} disabled={!checkValues.youtubeurl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlPinterest" data-value="pinteresturl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.pinteresturl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblPinterest" for="ctlPinterest">Pinterest</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlPinterest" data-value="pinteresturl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.pinteresturl} disabled={!checkValues.pinteresturl} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlWhatsApp" data-value="whatsappurl" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.whatsappurl} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblWhatsApp" for="ctlWhatsApp">WhatsApp</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlWhatsApp" data-value="whatsappurl" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.whatsappurl} disabled={!checkValues.whatsappurl} onChange={handleCheckChange} />
                </div>
            </Form>
        </div>
    )
}

export default MLeadFilters;